import { useDataObjectActionHandlers } from '../data-objects/useDataObjectActionHandlers';
import { OUTPUT_DATA_OBJECT_ROUTES } from './OutputDataObjects';
import { DataObjectView } from '@atlas-frontend/sdk';
import { DataObjectCreate } from '../data-objects/DataObjectCreate';

export const OutputDataObjectCreate = () => {
  const { handleSuccess, handleCancel } = useDataObjectActionHandlers(
    'outputDataObjectView'
  );

  return (
    <DataObjectCreate
      routes={OUTPUT_DATA_OBJECT_ROUTES}
      view={DataObjectView.OUT}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  );
};
